import React, {useContext} from 'react';
import { useTranslate } from 'react-redux-multilingual';
import swal from "sweetalert2";
import { IsAuthContext } from 'app/App';

const SelectFields = (props)=> {
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext)
    
    const handleChange = (e) => {
        if(props.multipleCards==='true'){
            let arr = [];
            //On crée un nouveau tableau avec les valeurs de tous les tableaux existant
            Object.entries(props.datas).forEach(([keyName, data]) => {
                arr = arr.concat(data)
            })
            if (e.target.value){
                //On crée un tableau qui reprend les valeurs du tableau sélectionné 
                let newArr = props.datas[props.keyName]
                //On rajoute la nouvelle valeur dans le nouveau tableau créé
                newArr.push(e.target.value)
                //On met à jour mon objet initial en indiquant que le nouveaut tableau remplaçera les valeurs de la clé sélectionné
                props.setDatas({...props.datas,[props.keyName]: newArr})
            }
        }else{
            if (e.target.value){
                if(props.datas.length>0){
                    props.setDatas([...props.datas, e.target.value])
                }else{
                    props.setEmptyConf(false)
                    props.setNoDefaultConf(false)
                    props.setDatas([e.target.value])
                }
            }
        }
    }

    const getLabel = (value) => {
        if (value === 'name') return t('itemName');
        if (value === 'price') return t('priceTtcB2c');
        if (value === 'price_b2b') return t('priceHtB2b');
        if (value === 'indice') return t('prmpIndice');
        if (value === 'image') return t('imageLink');
        if (value === 'quota_commande') return t('quantity');
        if (value === 'commande') return t('orderDate');
        if (value === 'tgc') return t('tgc', { taxe: authParam.company.nomenclature_tgc });
        if (value === 'expedition') return t('expectedDeliveryDate');
        if (value === 'reception') return t('expectedReceiptDate');
        if (value === 'user') return t('receivedBy');
        if (value === 'to_prepare') return t('itemToPrepare');
        if (value.startsWith('name_')) return t('packagingName') + ' ' + value.split('_')[1];
        if (value.startsWith('reference_')) return t('barcodePackaginglist') + ' ' + value.split('_')[1];
        if (value.startsWith('quantity_')) return t('packagedQuantity') + ' ' + value.split('_')[1];
        if (value.startsWith('price_')) return t('price') + ' ' + value.split('_')[1];
        return t(value) || value;
    };

    const selectedValues = props.multipleCards === 'true'
        ? Object.values(props.datas).flat()
        : Array.isArray(props.datas) ? props.datas : [];

    const availableFields = props.fields
        ? props.fields
            .filter(value => !selectedValues.includes(value))
            .map(value => ({ value, label: getLabel(value) }))
            .sort((a, b) => a.label.localeCompare(b.label))
        : [];

    return(
        <form onChange={(e) => handleChange(e)}>
            <div className="row">
                <div className="col form-group">
                    <label className="col-form-label col-form-label-sm">{t('labelSelectConfigue')}</label>
                    <select className="form-control form-control-md" >
                        <option value="">-- Select --</option>
                        {availableFields.map(({ value, label }) =>
                            <option key={value} value={value}>{label}</option>
                        )}
                    </select>
                </div>
            </div>
        </form>
    )
}

export default SelectFields ;